if (!customElements.get('quick-shop')) {
  class Quickshop extends HTMLElement {
    constructor() {
      super();

      this.parentCard = this.closest('[data-product-card]');

      // Bind popup toggle events
      this.parentCard.querySelectorAll('[data-quickshop-toggle]').forEach((button) => button.addEventListener('click', this.onPopupToggle.bind(this)));

      // Bind options view toggle events
      this.parentCard.querySelectorAll('[data-quickshop-options-toggle]').forEach((button) => button.addEventListener('click', this.onPopupOptionsToggle.bind(this, true)));

      this.parentCard.addEventListener('mouseleave', this.onPopupOptionsToggle.bind(this, false));

      // Bind option select events
      this.querySelectorAll('[data-quickshop-option]').forEach((option) => option.addEventListener('click', this.onOptionSelect.bind(this, option.value, option.dataset.inventoryQuantity)));
    }

    /**
     * Toggles the quickshop popup
     * @description Toggles the quickshop popup visibility.
     */
    onPopupToggle() {
      const popup = this.querySelector('[data-quickshop-popup]');
      const popupIsOpenClass = 'quickshop__popup--is-open';

      popup.classList.toggle(popupIsOpenClass);
    }

    /**
     * Toggles the options popup
     * @description Toggles the options visibility in the quickshop popup.
     */
    onPopupOptionsToggle(open = true) {
      const toggleBtn = this.querySelector('[data-quickshop-options-toggle]');
      const options = this.querySelector('[data-quickshop-options]');
      const hiddenClass = 'visibility-hidden';

      if (open) {
        toggleBtn?.classList.add(hiddenClass);
        options?.classList.remove(hiddenClass);
      } else {
        toggleBtn?.classList.remove(hiddenClass);
        options?.classList.add(hiddenClass);
      }
    }

    /**
     * Adds a variant to the cart
     * @description Adds the clicked option/variant to the cart leveraging the product form component.
     * @param {String} variantId
     * @param {String} inventoryQuantity
     */
    onOptionSelect(variantId, inventoryQuantity, event) {
      event.preventDefault();
      event.stopPropagation();

      const productForm = this.querySelector('product-form');
      const hiddenId = productForm.querySelector('input[name="id"]');
      const hiddenInventoryQty = productForm.querySelector('input[name="inventory_quantity"]');
      const submitButton = productForm.querySelector('[type="submit"]');

      hiddenId.value = variantId;
      hiddenInventoryQty.value = inventoryQuantity;

      // Submit add to cart
      submitButton.click();
    }
  }

  window.Quickshop = Quickshop;
  customElements.define('quick-shop', Quickshop);
}
